import SecondServer from '../database/SecondServer'
import { siteAccessCode } from '../database/apiv2SiteAccessor'
import {urlSiteDC} from '../database/apiUrls';

export default function Disconnect (props) {
  let resp = null
  try {
    const site = props.getActiveSite();
    if(site) {
      const url = urlSiteDC(siteAccessCode(site))
      const ss = new SecondServer(props)
      resp = ss.apiInsertData(url)
    }
  }
  catch (ex) {
    resp = ex
  }
  props?.setActiveSite(null)
  return resp
}
